import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RtlDetectorService } from '../../../../../../shared/services/rtl-detector.service';

@Component({
  selector: 'app-product-catalog',
  templateUrl: './product-catalog.component.html',
  styleUrls: ['./product-catalog.component.scss'],
})
export class ProductCatalogModal implements OnInit {
  public pcmUrl: string;
  public isRTL = false;

  constructor(
    private pcmDialogRef: MatDialogRef<MatDialog>,
    private rtlDetector: RtlDetectorService,
    @Inject(MAT_DIALOG_DATA) data: { pcmUrl: string },
  ) {
    this.pcmUrl = data.pcmUrl;
  }

  ngOnInit() {
    this.isRTL = this.rtlDetector.activeLangRTL();
  }

  closeDialog(response?: any) {
    this.pcmDialogRef.close(response);
  }
}
